import styled from 'styled-components';

var RawSvg = require("./chevron.svg");

var getRotationAmount = function getRotationAmount(direction) {
  switch (direction) {
    case 'right':
      return '90deg';

    case 'down':
      return '180deg';

    case 'left':
      return '270deg';

    case 'up':
    default:
      return '0deg';
  }
};

var Svg = /*#__PURE__*/styled(RawSvg).withConfig({
  displayName: "Chevronstyles__Svg",
  componentId: "sc-1sn10bp-0"
})(["display:inline-flex;stroke:", ";stroke-width:2.3;transition:transform 0.15s ease-out;transform:rotate(", ");"], function (_ref) {
  var color = _ref.color;
  return color;
}, function (_ref2) {
  var direction = _ref2.direction;
  return getRotationAmount(direction);
});
export { Svg };